import axiosInstance from "@/helpers/axios";

export default {
  namespaced: true,
  actions: {
    getFeedbacks({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`/app-feedback?type=feedback`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    getSuggestions({ dispatch, commit }) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get(`/app-feedback?type=suggestion`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
};
